import React from "react";
import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import AccountInformation from "AdminSettings/routes/AccountInformation";
import OrganizationalStructure from "AdminSettings/routes/OrganizationalStructure";
import SchoolInformation from "AdminSettings/routes/SchoolInformationWrapper";
import AcademicYears from "AdminSettings/routes/AcademicYears";
import GradeLevelsWrapper from "AdminSettings/routes/GradeLevelsWrapper";

import LoginConfigurationManager from "Administrator/routes/SchoolSetup/routes/LoginConfigurationManager";
import TeacherSetup from "Administrator/routes/SchoolSetup/routes/TeacherSetup";
import SyncV2 from "Administrator/routes/SchoolSetup/routes/SyncV2";

// POC 1 only — Core Admin Portal route. Sibling of `AdminSettings`
// (`/platform/accountSettings`). Reuses LMS route components for the real
// items (account/org/school/academic-years/grade-levels + login config + staff
// + roster sync); placeholder routes render a title-only page for Academic
// Types Setup + Subscription Plan. No screens are reimplemented here.

const makePlaceholderRoute = ({ path, labelLocale }) => ({
  path,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "core-settings" */ "./components/CoreSettingsPlaceholder"
    ).then(({ default: CoreSettingsPlaceholder }) => {
      const Wrapper = () => (
        <CoreSettingsPlaceholder labelLocale={labelLocale} />
      );
      Wrapper.displayName = `CoreSettingsPlaceholder(${path})`;
      return Wrapper;
    })
  ),
});

export default store => ({
  path: "coreSettings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "core-settings" */ "./components/CoreSettingsShell"
      ),
      import(
        /* webpackChunkName: "administrator" */ "Administrator/modules/AdministratorModule"
      ),
      import(
        /* webpackChunkName: "admin-schoolSetup" */ "SchoolSetup/modules/SchoolSetupModule"
      ),
    ]).then(([shellModule, administratorReducerModule, schoolSetupModule]) => {
      injectReducer(store, {
        key: "administrator",
        reducer: administratorReducerModule.default,
      });
      injectReducer(store, {
        key: "schoolSetup",
        reducer: schoolSetupModule.default,
      });
      return shellModule.default;
    })
  ),
  childRoutes: _.map([
    AccountInformation(store),
    OrganizationalStructure(store),
    SchoolInformation(store),
    AcademicYears(store),
    GradeLevelsWrapper(store),
    LoginConfigurationManager(store),
    TeacherSetup(store),
    SyncV2(store),
    makePlaceholderRoute({
      path: "academicTypesSetup",
      labelLocale: "common:academic_types_setup",
    }),
    makePlaceholderRoute({
      path: "subscriptionPlan",
      labelLocale: "common:subscription_plan",
    }),
  ]),
});
